class A {
  constructor(element) {
    this.element = document.querySelectorAll(element);
  }

  on(event, callback) {
    this.element.forEach((element) => {
      element.addEventListener(event, callback);
    });
  }


  slideLeft() {
    this.element.style.background = 'red';

    return this;
  }

  changeHeight() {
    this.element.style.height = '200px';

    return this;
  }
}

export function $$(element) {
  return new A(element);
}